/**
 * Feature flag for the contamination declaration (DoC) area: the post-event
 * follow-up, the editor route, the event-history status column, the asset
 * nav entry and breadcrumb, and the About-page welcome bullet. Baked in at
 * build time by CRA: true on testing, staging and in local dev
 * (.env.testing / .env.staging / .env.local), false in production until the
 * feature is released there. The DoC changelog entries are parked in an HTML
 * comment in CHANGELOG.md for the same reason. Kept as a module so tests can
 * mock it.
 */
export const isContaminationDeclarationsEnabled = (): boolean =>
    process.env.REACT_APP_ENABLE_CONTAMINATION_DECLARATIONS === 'true';
